<template>
    <transition name="modal-fade">
        <div
            v-if="showAny"
            class="fixed inset-0 z-40 flex items-center justify-center bg-blue"
        >
            <div
                class="absolute top-0 mx-auto hidden w-full max-w-[1400px] items-center justify-between pr-6 lg:flex lg:h-28 lg:px-8"
            >
                <a
                    :href="siteUrl"
                    class="hidden h-full items-center pl-6 lg:flex lg:px-0"
                    target="_blank"
                >
                    <img
                        src="https://d1axg9pbn00pk6.cloudfront.net/site/1P5-logo.svg"
                        class="h-16 w-auto"
                        alt="1PointFive Logo"
                    />
                </a>
            </div>
            <transition name="modal-bounce" appear>
                <div
                    class="modal-content relative mx-4 my-4 max-h-[90%] max-w-lg bg-white p-9 shadow-xl"
                >
                    <component :is="activeComponent" />
                </div>
            </transition>
        </div>
    </transition>
</template>

<script setup lang="ts">
import { computed, onMounted } from "vue";
import { useQuizStore } from "../stores/quizStore";
import ShareModal from "../modals/ShareModal.vue";

const quiz = useQuizStore();

const showAny = computed(() => quiz.isShareModal);

const activeComponent = computed(() => {
    if (quiz.isShareModal) return ShareModal;
    return null;
});

const siteUrl = computed(() => quiz.siteUrl);
</script>

<style>
.modal-content::-webkit-scrollbar-thumb {
    border-radius: 0px;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
    transition: opacity 0.25s ease;
}
.modal-fade-enter-from,
.modal-fade-leave-to {
    opacity: 0;
}
.modal-bounce-enter-active {
    animation: modalIn 0.3s ease-in-out;
}

@keyframes modalIn {
    from {
        transform: scale(1);
        opacity: 0;
    }
    50% {
        transform: scale(1.01);
    }
    70% {
        transform: scale(0.99);
        opacity: 1;
    }
    to {
        transform: scale(1);
    }
}
</style>
